/**
 * Created by daiyingfeng on 2017/4/24.
 */

import isEmpty from 'lodash/isEmpty'
import 'whatwg-fetch'
// import { Toast } from 'antd-mobile';
import { hashHistory } from 'react-router'
import util from '../util';
import { message } from 'antd';
//fetch 部分处理
const server = window.server||"http://localhost:8090";

const { getAccessToken } = util;

const checkReject = (obj)=>{
    let isFalse = false;
    // console.log("---obj:",obj);
    if(obj.errorCode && obj.errorCode==="103") { //session异常，如果有路由就强制跳转
        console.log("obj.errorCode:",obj.errorCode);
        alert("session过期，请重新登陆！",5);
        //跳转登陆
        hashHistory.push("/")
        isFalse = true;
    }else if (obj.code === 113) {
        message.error(obj.msg);
        hashHistory.push("/login");
    }else if(typeof obj.status !== 'undefined' && (!obj.status )) {
        // console.log("obj.status:",obj.status);
        // //message.error("接口业务逻辑错误："+ obj.error,5);
        // isFalse = true;
    }
    return isFalse;
}

const Base = {
    getFd:(values,paramType) => {
        if(paramType==="json") {
            //values.Authorization = "Bearesr "+Base.getLs("token");
            return JSON.stringify(values);
        }else {
            let fd = "";
            for(let p in values) {
                if(p === 'jsonstr' && typeof values[p] === 'object'){
                    fd += p+"="+JSON.stringify(values[p]).replace(/\\/g,'')+"&";
                }else{
                    fd += p+"="+encodeURIComponent(values[p])+"&";
                }
            }
            //fd += "Authorization=Bearesr "+Base.getLs("token")+"&";
            fd += "__random__="+new Date().getTime();
            return fd;
        }
    },
    getFetchParams:(method,params,paramType)=>{
        let obj = {
            method:method,
            headers: {
                'Content-Type': paramType === 'json' ? 'application/json' : 'application/x-www-form-urlencoded;charset=utf-8',
                // 'X-Requested-With':'XMLHttpRequest',
            },
        };
        if(server==="") {
            obj.credentials = "include";
        }

        if(!isEmpty(params) && method.toUpperCase() !== 'GET') {
            obj.body = Base.getFd(params,paramType);
        }
        return obj;
    },
    getRequestWithCookie:(method,params,cookie,paramType) =>{
      let obj = {
          method : method,
          headers:{
              'Content-Type': paramType === 'json' ? 'application/json' : 'application/x-www-form-urlencoded;charset=utf-8',
              // 'X-Requested-With':'XMLHttpRequest',
          }
      };
      // if(cookie){
      //     obj.headers = {...obj.headers,'ecId':cookie}
      // }
      if(!isEmpty(params) && method.toUpperCase() !== 'GET'){
          obj.body = Base.getFd(params,paramType);
      }
      console.log(JSON.stringify(obj));
      return obj;
    },
    callApi:(url, method = 'GET', params = {}, type = 'json', paramType = 'json') => {
        // Toast.loading('Loading...', 0)
        url = `${server}${url}`;
        if(!params.access_token) params.access_token = getAccessToken();

        if(isEmpty(params) || method.toUpperCase() === 'POST') {
            // url = `${url}?Authorization=Bearesr ${Base.getLs("eim_token")}`
        }
        else {
            // url = `${url}`            
        }
        if (method.toUpperCase() === 'GET' && !isEmpty(params)) {
            url = `${url}?${Base.getFd(params,paramType)}`;
        }
        // console.log('url = ' + url);

        // if(method.toUpperCase() === 'GET' && isEmpty(params)) {
        //     url = `${url}?Authorization=Bearesr ${Base.getLs("token")}`
        // }
        // console.log("method.toUpperCase():",method.toUpperCase() !== 'GET'," isEmpty(params):",isEmpty(params));
        // if(method.toUpperCase() !== 'GET' && isEmpty(params)) {
        //     url = `${url}?Authorization=Bearesr ${Base.getLs("token")}`
        //     //params.Authorization = "Bearesr "+Base.getLs("token");
        //     console.log("yes!");
        // }
        //console.log("url:",url," params:",Base.getFetchParams(method, params, paramType));
        return new Promise((resolve,reject) => {
            fetch(url, Base.getFetchParams(method, params, paramType)).then(function(response) {
                let data = "";
                // console.log(type==="json");
                // console.log(response.json(),'111')
                if(type==="json")
                    data = response.json();
                else
                    data = response.text();
                return data
            }).then(data => {
                // Toast.hide();
                if(checkReject(data)) {
                    reject(`${url} fetch 请求异常: ${data.error || 'error'}`);
                }
                else {
                    resolve(data);
                }
            }).catch(function(ex) {
                // Toast.hide();
                console.log(ex);
                reject(`${url} fetch 数据处理异常: ${ex}`);
            });
        });
    },
    setLs(key,value) {
        window.localStorage[key] = value;
    },
    getLs(key) {
        return window.localStorage[key];
    },
    callApiWithCookie :(url,method = "GET", params ,cookie , paramType = 'json') =>{
        url = `${server}${url}`;
        if (method.toUpperCase() === 'GET' && !isEmpty(params)) {
            url = `${url}?${Base.getFd(params,paramType)}`;
        }
        return new Promise((resolve,reject) => {
            fetch(url, Base.getRequestWithCookie(method, params,cookie, paramType)).then(function(response) {
                let data = response.json();
                return data;
            }).then(data => {
                if(checkReject(data)) {
                    reject(`${url} fetch 请求异常: ${data.error || 'error'}`);
                }
                else {
                    resolve(data);
                }
            }).catch(function(ex) {
                console.log(ex);
                reject(`${url} fetch 数据处理异常: ${ex}`);
            });
        });
    }

};

export default Base;


// WEBPACK FOOTER //
// ./src/tool/base.js